export default __webpack_public_path__ + "static/media/Slide2.7361a95b.png";